export default "__VITE_ASSET__B0OR0ms___"